import classNames from 'classnames';
import { useState } from 'react';

import { Image } from '../Image';

type Props = {
  eagerLoading?: boolean;
  product: Product;
};

const ProductTileImage: React.FC<Props> = ({
  eagerLoading = false,
  product,
}) => {
  const [sourceLoaded, setSourceLoaded] = useState(false);

  return (
    <div
      className={classNames(
        'relative z-10 flex w-full cursor-pointer overflow-hidden',
        {
          'bg-neutral-1': sourceLoaded,
          'animate-pulse bg-neutral-2': !sourceLoaded,
        },
      )}
    >
      <Image
        alt={product.alt || product.title}
        eagerLoading={eagerLoading}
        hoverEffect
        onLoad={() => setSourceLoaded(true)}
        size={{
          sm: { ratio: '3/4', span: 6 },
          md: { ratio: '3/4', span: 3 },
          lg: { ratio: '3/4', span: 3 },
        }}
        src={product.image}
      />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default ProductTileImage;
